import DataType from '@linc-technologies/linced-common/enums/data-type';
import InputType from '@linc-technologies/linced-common/enums/input-type';

// The fragment attr holding a value of each DataType.
export type ValueKey =
  | 'valueString'
  | 'valueList'
  | 'valueInt'
  | 'valueFloat'
  | 'valueBool'
  | 'valueValueList';

export function getValueKey(datatype: number | undefined): ValueKey | '' {
  let key: ValueKey | '' = '';
  switch (datatype) {
    case DataType.STRING:
    case DataType.HTML:
      key = 'valueString';
      break;
    case DataType.LIST:
      key = 'valueList';
      break;
    case DataType.INTEGER:
      key = 'valueInt';
      break;
    case DataType.FLOAT:
      key = 'valueFloat';
      break;
    case DataType.BOOLEAN:
      key = 'valueBool';
      break;
    case DataType.VALUE_LIST:
      key = 'valueValueList';
  }

  return key;
}

export function getValueDefault(
  datatype: number | undefined,
): string | number | boolean | unknown[] {
  let defaultValue: string | number | boolean | unknown[] = '';
  switch (datatype) {
    case DataType.STRING:
    case DataType.HTML:
      defaultValue = '';
      break;
    case DataType.LIST:
    case DataType.VALUE_LIST:
      defaultValue = [];
      break;
    case DataType.INTEGER:
    case DataType.FLOAT:
      defaultValue = 0;
      break;
    case DataType.BOOLEAN:
      defaultValue = false;
      break;
  }

  return defaultValue;
}

export function getDefaultDatatype(inputType: number | undefined) {
  switch (inputType) {
    case InputType.CHECKBOX:
    case InputType.MULTI_SELECT:
      return DataType.LIST;
    case InputType.NUMBER:
      return DataType.INTEGER;
    case InputType.SWITCH:
      return DataType.BOOLEAN;
    default:
      return DataType.STRING;
  }
}
